<template>
  <f7-page name="left menu"  class="left-menu">
    <!-- navbar -->
    <!-- <f7-navbar title="AZ Menu" class="left-nav BG menu-icon">
      <a class="panel-close" href="#"><i class="az-icon-menu"></i></a>
    </f7-navbar> -->

    <div class="menu-header BG">
      <div class="title">AZ Connect Menu</div>
      <div class="menu-header-icon">
        <a class="panel-close" href="#"><i class="az-icon-menu"></i></a>
      </div>
    </div>
    
        <!-- Left Menu List -->
        <div class="list AZLMenu">
          <ul>
            <!-- Home -->
            <li>
              <f7-link href="/" class="item-link item-content" view="#main-view" panel-close>
                <div class="item-media">
                  <i class="az-icon-home-house-interface-ui-website"></i>
                  </div>
                <div class="item-inner">
                  <div class="item-title">Home</div>
                </div>
              </f7-link>
            </li>
            <li>
              <f7-link href="/profile/" class="item-link item-content" view="#main-view" panel-close>
                <div class="item-media">
                  <i class="az-icon-avatar-user-profile-account-man"></i>
                  </div>
                <div class="item-inner">
                  <div class="item-title">Profile</div>
                </div>
              </f7-link>
            </li>
            <li>
              <f7-link href="/calendar/" class="item-link item-content" view="#main-view" panel-close>
                <div class="item-media">
                  <i class="az-icon-calendar-date-schedule-appointment"></i>
                  </div>
                <div class="item-inner">
                  <div class="item-title">Calendar</div>
                </div>
              </f7-link>
            </li>
            <!-- My Events -->
            <li>
              <f7-link href="/upcoming/" class="item-link item-content" view="#main-view" panel-close>
                <div class="item-media">
                  <i class="az-icon-calendar-date-schedule"></i>
                  </div>
                <div class="item-inner">
                  <div class="item-title">My Events</div>
                  <div class="item-after"></div>
                </div>
              </f7-link>
            </li>
            <li v-if="$root.user.user_type != 'astrazeneca_sales'">
              <f7-link href="/articles/" class="item-link item-content" view="#main-view" panel-close>
                <div class="item-media">
                  <i class="az-icon-document-copy-duplicate-office"></i>
                  </div>
                <div class="item-inner">
                  <div class="item-title">Articles</div>
                </div>
              </f7-link>
            </li>
            <li>
              <f7-link href="/news/" class="item-link item-content" view="#main-view" panel-close>
                <div class="item-media">
                  <i class="az-icon-website-web-site-page-internet"></i>
                  </div>
                <div class="item-inner">
                  <div class="item-title">News</div>
                </div>
              </f7-link>
            </li>
            <li>
              <f7-link href="/about/" class="item-link item-content" view="#main-view" panel-close>
                <div class="item-media">
                  <i class="az-icon-document-file-text-business"></i>
                  </div>
                <div class="item-inner">
                  <div class="item-title">About</div>
                </div>
              </f7-link>
            </li>
            <li>
              <f7-link href="#" @click="$root.logoutFromApp" class="item-link item-content" view="#main-view" panel-close>
                <div class="item-media">
                  <i class="az-icon-logout-account-exit-user"></i>
                  </div>
                <div class="item-inner">
                  <div class="item-title">Logout</div>
                </div>
              </f7-link>
            </li>
          </ul>
        </div>
        <!-- End Left Menu List -->

  </f7-page>
</template>
<script>
export default {

}
</script>
